// Theme: laser
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'laser',
  name: 'LASER',
  tagline: 'LASER',
  description: 'Raio laser verde-agua cortando escuridao. Precisao cirurgica.',
  category: 'neon-cyber',
  tier: 'rare',
  basePrice: 1200,
  swatches: ['#0F3C33', '#93E8D1', '#1A4F42', '#F2FFFB'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '0px',
      '--shadow-card': 'none',
      '--shadow-card-active': '0 12px 32px rgba(147, 232, 209, 0.08)'
    },
    shellClasses: 'font-mono theme-laser'
  },
  colorVars: {
    '--accent': '#2DBA94',
    '--accent-foreground': '#0F3C33',
    '--background': '#0F3C33',
    '--border': '#2DBA94',
    '--card': '#1A4F42',
    '--card-border-active': 'rgba(147, 232, 209, 0.08)',
    '--card-completed': '#1E5B4C',
    '--card-foreground': '#F2FFFB',
    '--card-glow': 'rgba(147, 232, 209, 0.08)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0F3C33',
    '--foreground': '#F2FFFB',
    '--hold-fill': '#93E8D1',
    '--input': '#1A4F42',
    '--modal-bg': '#0F3C33',
    '--modal-border': '#2DBA94',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': 'none',
    '--muted': '#1A4F42',
    '--muted-foreground': '#93E8D1',
    '--nav-active': '#93E8D1',
    '--nav-bg': '#0F3C33',
    '--popover': '#1A4F42',
    '--popover-foreground': '#F2FFFB',
    '--primary': '#93E8D1',
    '--primary-foreground': '#0F3C33',
    '--ring': '#93E8D1',
    '--secondary': '#2DBA94',
    '--secondary-foreground': '#0F3C33',
    '--streak': '#93E8D1',
    '--success': '#22c55e',
    '--success-foreground': '#0F3C33',
    '--xp': '#93E8D1',
    '--xp-bg': '#1A4F42'
  },
  resolvedVars: {
    '--accent': '#2DBA94',
    '--accent-foreground': '#0F3C33',
    '--accent-foreground-hsl': '168 60% 15%',
    '--accent-foreground-oklch': 'from #0F3C33 l c h',
    '--accent-hsl': '164 61% 45%',
    '--accent-oklch': 'from #2DBA94 l c h',
    '--background': '#0F3C33',
    '--background-hsl': '168 60% 15%',
    '--background-oklch': 'from #0F3C33 l c h',
    '--border': '#2DBA94',
    '--border-hsl': '164 61% 45%',
    '--border-oklch': 'from #2DBA94 l c h',
    '--border-w': '1px',
    '--card': '#1A4F42',
    '--card-border-active': 'rgba(147, 232, 209, 0.08)',
    '--card-completed': '#1E5B4C',
    '--card-completed-hsl': '165 50% 24%',
    '--card-completed-oklch': 'from #1E5B4C l c h',
    '--card-foreground': '#F2FFFB',
    '--card-foreground-hsl': '162 100% 97%',
    '--card-foreground-oklch': 'from #F2FFFB l c h',
    '--card-glow': 'rgba(147, 232, 209, 0.08)',
    '--card-hsl': '165 50% 21%',
    '--card-oklch': 'from #1A4F42 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0F3C33',
    '--destructive-foreground-hsl': '168 60% 15%',
    '--destructive-foreground-oklch': 'from #0F3C33 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#F2FFFB',
    '--foreground-hsl': '162 100% 97%',
    '--foreground-oklch': 'from #F2FFFB l c h',
    '--hold-fill': '#93E8D1',
    '--hold-fill-hsl': '164 65% 74%',
    '--hold-fill-oklch': 'from #93E8D1 l c h',
    '--input': '#1A4F42',
    '--input-hsl': '165 50% 21%',
    '--input-oklch': 'from #1A4F42 l c h',
    '--modal-bg': '#0F3C33',
    '--modal-bg-hsl': '168 60% 15%',
    '--modal-bg-oklch': 'from #0F3C33 l c h',
    '--modal-border': '#2DBA94',
    '--modal-border-hsl': '164 61% 45%',
    '--modal-border-oklch': 'from #2DBA94 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': 'none',
    '--muted': '#1A4F42',
    '--muted-foreground': '#93E8D1',
    '--muted-foreground-hsl': '164 65% 74%',
    '--muted-foreground-oklch': 'from #93E8D1 l c h',
    '--muted-hsl': '165 50% 21%',
    '--muted-oklch': 'from #1A4F42 l c h',
    '--nav-active': '#93E8D1',
    '--nav-active-hsl': '164 65% 74%',
    '--nav-active-oklch': 'from #93E8D1 l c h',
    '--nav-bg': '#0F3C33',
    '--nav-bg-hsl': '168 60% 15%',
    '--nav-bg-oklch': 'from #0F3C33 l c h',
    '--popover': '#1A4F42',
    '--popover-foreground': '#F2FFFB',
    '--popover-foreground-hsl': '162 100% 97%',
    '--popover-foreground-oklch': 'from #F2FFFB l c h',
    '--popover-hsl': '165 50% 21%',
    '--popover-oklch': 'from #1A4F42 l c h',
    '--primary': '#93E8D1',
    '--primary-foreground': '#0F3C33',
    '--primary-foreground-hsl': '168 60% 15%',
    '--primary-foreground-oklch': 'from #0F3C33 l c h',
    '--primary-hsl': '164 65% 74%',
    '--primary-oklch': 'from #93E8D1 l c h',
    '--radius': '0px',
    '--ring': '#93E8D1',
    '--ring-hsl': '164 65% 74%',
    '--ring-oklch': 'from #93E8D1 l c h',
    '--secondary': '#2DBA94',
    '--secondary-foreground': '#0F3C33',
    '--secondary-foreground-hsl': '168 60% 15%',
    '--secondary-foreground-oklch': 'from #0F3C33 l c h',
    '--secondary-hsl': '164 61% 45%',
    '--secondary-oklch': 'from #2DBA94 l c h',
    '--shadow-card': 'none',
    '--shadow-card-active': '0 12px 32px rgba(147, 232, 209, 0.08)',
    '--streak': '#93E8D1',
    '--streak-hsl': '164 65% 74%',
    '--streak-oklch': 'from #93E8D1 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#0F3C33',
    '--success-foreground-hsl': '168 60% 15%',
    '--success-foreground-oklch': 'from #0F3C33 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(164 65% 74% / 0.15)',
    '--xp': '#93E8D1',
    '--xp-bg': '#1A4F42',
    '--xp-bg-hsl': '165 50% 21%',
    '--xp-bg-oklch': 'from #1A4F42 l c h',
    '--xp-hsl': '164 65% 74%',
    '--xp-oklch': 'from #93E8D1 l c h'
  }
}
